import { Button } from "@/components/atoms"
import { CartItems, CartSummary } from "@/components/organisms"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { retrieveCart } from "@/lib/data/cart"
import CartPromotionCode from "../CartReview/CartPromotionCode"
import { getTranslate } from "@/tolgee/server"
import Analytics from "@/components/molecules/Analytics/Analytics"
import { Track } from "@/components/molecules/Track/Track"

export const fetchCache = 'force-no-store'

export const Cart = async () => {
  const cart = await retrieveCart()
  const t = await getTranslate()

  // 检测多商家购物车：提取唯一卖家ID
  const sellerIds = new Set(
    cart?.items
      ?.map((item: any) => item.product?.seller?.id)
      .filter(Boolean) ?? []
  )
  const isMultiSeller = sellerIds.size > 1
  return (
    <>
      {<Track event="view_cart" data={{
        currency: cart?.currency_code,
        value: cart?.total,
        items: cart?.items?.map(i => ({
          item_id: i.variant_sku,
          item_name: i.title,
          price: i.unit_price,
          quantity: i.quantity
        }))
      }} />}
      <Analytics
        event="view_cart"
        data={{
          currency: cart?.currency_code,
          value: cart?.total,
          items: JSON.stringify(
            cart?.items?.map((i: any) => ({
              item_id: i.variant_sku,
              item_name: i.title,
              price: i.unit_price,
              quantity: i.quantity,
            })) || []
          ),
        }}
      />
      <div className="flex-1 min-w-0">
        <CartItems cart={cart} />
      </div>
      <div className="w-[288px] shrink-0">
        <div className="w-full mb-6 border border-[#e5e5e5] rounded-[13px] p-4">
          <CartPromotionCode cart={cart as any} />
        </div>
        <div className="border border-[#e5e5e5] rounded-[13px] p-4 h-fit">
          <CartSummary
            item_total={cart?.item_total || 0}
            shipping_total={cart?.shipping_total || 0}
            total={cart?.total || 0}
            currency_code={cart?.currency_code || ""}
            tax={cart?.tax_total || 0}
          />
          {/* 多商家结账警告 */}
          {isMultiSeller && (
            <div className="bg-amber-50 border border-amber-300 rounded-md p-4 mb-4">
              <p className="text-amber-800 text-sm font-medium">
                {t("cart_checkout.multi_seller_warning")}
              </p>
            </div>
          )}
          <LocalizedClientLink
            href={!cart || !cart.items || cart.items.length === 0 || isMultiSeller ? "#" : "/checkout"}
            needLogin
            className={
              !cart || !cart.items || cart.items.length === 0 || isMultiSeller ? "pointer-events-none" : ""
            }
          >
            <Button
              className="w-full py-3 flex justify-center items-center mt-4"
              disabled={!cart || !cart.items || cart.items.length === 0 || isMultiSeller}
            >
              {t("cart_checkout.go_to_checkout")}
            </Button>
          </LocalizedClientLink>
        </div>
      </div>
    </>
  )
}
